import React from "react";
import { PackageMinus } from "lucide-react";
import { EuRelabelCheckInProductShortage } from "src/types";
import { QUANTITY_CHANGE_REASON_LABEL } from "src/constants/relabelCases";

interface LoggedShortagesListProps {
  shortages: EuRelabelCheckInProductShortage[];
}

const LoggedShortagesList: React.FC<LoggedShortagesListProps> = ({ shortages }) => {
  if (shortages.length === 0) return null;

  return (
    <div className="space-y-2">
      <h4 className="text-xs font-semibold uppercase tracking-wide text-amber-700 flex items-center gap-1.5">
        <PackageMinus className="w-3.5 h-3.5" />
        Logged Shortages
      </h4>
      <ul className="space-y-2">
        {shortages.map((shortage) => (
          <li key={shortage.productId} className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm">
            <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
              <span className="font-mono font-semibold text-secondary-900">{shortage.skuName}</span>
              <span className="text-xs text-secondary-700">{shortage.productName}</span>
            </div>
            <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-secondary-700 tabular-nums">
              <span>
                Expected <span className="font-semibold">{shortage.expectedQty}</span>
              </span>
              <span>
                Received <span className="font-semibold">{shortage.receivedQty}</span>
              </span>
              <span className="text-amber-800">
                Short <span className="font-semibold">{shortage.shortageQty}</span>
              </span>
              <span className="rounded border border-amber-300 bg-white px-1.5 py-0.5 font-medium text-amber-800">
                {QUANTITY_CHANGE_REASON_LABEL[shortage.reason]}
              </span>
            </div>
            {shortage.reasonNote && <p className="mt-1 text-xs text-secondary-600 italic">"{shortage.reasonNote}"</p>}
            <p className="mt-1 text-[11px] text-secondary-500">
              Logged by {shortage.loggedByEmail} ·{" "}
              {shortage.loggedAt ? new Date(shortage.loggedAt).toLocaleString() : "—"}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export { LoggedShortagesList };
